<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid p-0 px-3">
    <div class="row mt-3">
      <div class="col" style="height:100%;">
        <div class="timeline timeline-left">
          <div class="timeline-container" id="timeline-container-id">

            <div class="timeline-row" style="z-index: unset !important;" v-for="(val, index) in logs">
              <div class="timeline-icon">
                <div v-bind:class=""></div>
              </div>
              <div class="card shadow-0 border-0 history_contanier skin light-bg p-3" style="display:block">
                <span class="text-default" v-html="val.DateCreated"></span>
                <span class="text-default" v-html="val.UserName"></span>
                <map-button v-show="val.Latitude != null && val.Latitude != ''" v-bind:latitude="val.Latitude" v-bind:longitude="val.Longitude" class="ml-1"></map-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  let msg = "";
 
  export default {
    name: "qrcode-logs",
    components: {
    },
    props: {
      qrcodeId: {
        type: Number,
        default: -1
      },
    },
    data() {
      return {
        msg: "",
        logs: [],
      };
    },
    methods: {
      getQRCodeLogs(qrcodeId) {
        try {
          this.$http.get('/api/qrcodes/v1/' + qrcodeId + "/Logs").then(async response => {
            var logResponse = response.data;
            this.logs = [];
            for (var i = 0; i < logResponse.length; i++) {
              this.logs.push(logResponse[i])
            }
            this.$forceUpdate();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      }
    },
     
    watch: {
      qrcodeId: function (newVal, oldVal) {
        if (newVal > 0) {
          this.getQRCodeLogs(newVal);
        }
      },
    },

    mounted() {      
      _componentValidation('#createQRCodeForm')
      if (this.qrcodeId > 0) {
        this.getQRCodeLogs(this.qrcodeId);
      }
    },

    computed: {
    }
  };
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/qrcode/qrcode-logs.vue